import {
  Background,
} from 'components/index'

export default ({ imgSrc, image, children }) => (
  <header className="tt-header">
    <Background header imgSrc={imgSrc} image={image}>
      {children
        ? <div className="tt-header-content">
            {children}
          </div>
        : null
      }
    </Background>
  </header>
)
